/**
 * Test IDs for the Device page and all its sub-components.
 *
 * Naming convention:  {page}-{section}-{element}-{qualifier?}
 * All IDs are kebab-case and stable — do NOT use display labels or i18n strings.
 *
 * Usage:
 *   import { DEVICE_TEST_IDS as TID } from "@/constant/testIds/device.testIds";
 */

export const DEVICE_TEST_IDS = {
  // ── Page shell ────────────────────────────────────────────────────────────
  PAGE: 'device-page',

  // ── Toolbar ───────────────────────────────────────────────────────────────
  SEARCH_INPUT: 'device-search-input',
  EXPORT_BTN: 'device-export-btn',
  FILTER_DROPDOWN: 'device-filter-dropdown',
  FILTER_DROPDOWN_OPERATOR: 'device-filter-dropdown-operator',
  FILTER_DROPDOWN_MARKET: 'device-filter-dropdown-market',
  DEVICE_TYPE_SELECT: 'device-type-select',
  STATUS_FILTER: 'device-status-filter',

  // ── Table ─────────────────────────────────────────────────────────────────
  TABLE: 'device-table',
  TABLE_ROW: (id: string) => `device-table-row-${id}`,

  // ── Column cells (per-row, keyed by sourceId) ─────────────────────────────
  COL_OPERATOR_ID: (id: string) => `device-col-operator-id-${id}`,
  COL_MARKET_ID: (id: string) => `device-col-market-id-${id}`,
  COL_DEVICE_ID: (id: string) => `device-col-device-id-${id}`,
  COL_SERIAL_NO: (id: string) => `device-col-serial-no-${id}`,
  COL_TYPE: (id: string) => `device-col-type-${id}`,
  COL_LAST_SYNC: (id: string) => `device-col-last-sync-${id}`,
  COL_STATUS: (id: string) => `device-col-status-${id}`,
  COL_CREATED_ON: (id: string) => `device-col-created-on-${id}`,
  COL_UPDATED_ON: (id: string) => `device-col-updated-on-${id}`,

  // ── Expanded row panel ───────────────────────────────────────────────
  EXPANDED_PANEL: 'device-expanded-panel',
  EXPANDED_UUIDS: 'device-expanded-uuids',
  EXPANDED_DETAILS: 'device-expanded-details',
} as const;
